import { render, staticRenderFns } from "./recipeDetail.vue?vue&type=template&id=0fd10489"
import script from "./recipeDetail.vue?vue&type=script&lang=js"
export * from "./recipeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports